import { REQUEST_STATUS_TO_TEXT } from '@/entities/request'
import {
    DomainRecruiterNewDriverStatusEnum as RecruitmentConfirmStatus,
    V1RequestStateStringEnum as RequestStatus,
    type V1UserRequestModel,
} from '@/shared/api'

const RECRUITMENT_CONFIRM_STATUS_CAN_BE_DECLINED = new Set([
    RecruitmentConfirmStatus.RecruiterNewDriverStatusNotified,
    RecruitmentConfirmStatus.RecruiterNewDriverStatusNew,
    RecruitmentConfirmStatus.RecruiterNewDriverStatusConfirmed,
])

export const getRequestStatusText = (
    userRequest: V1UserRequestModel,
    recruitmentConfirmStatus: RecruitmentConfirmStatus
) => {
    if (userRequest.deleted_at) {
        return 'Удалено'
    }

    if (
        RECRUITMENT_CONFIRM_STATUS_CAN_BE_DECLINED.has(recruitmentConfirmStatus) &&
        userRequest.state === RequestStatus.requestStateDeclineString
    ) {
        return `${REQUEST_STATUS_TO_TEXT[userRequest.state]}, исправьте данные`
    }

    return REQUEST_STATUS_TO_TEXT[userRequest.state]
}
